import * as React from 'react'
import type {RouteComponentProps, RouteProps} from 'react-router-dom'
import {Route} from 'react-router-dom'
import type {OmitStrict} from 'type-zoo'
import {useSelector} from '~/redux/hooks'
import {Redirect} from '~/routing/ReactRouterLinks'
import {staticURLs} from '~/routing/sitemap'
import type {ROUTE_TYPE_KEY, TPropsCustomRouteComponentsGet} from '../types'

const ROUTE_TYPE = 'NotSignedInRoute'

// all NotSignedIn routes get these props, extending what RouteComponentProps provides
export interface IPropsGuaranteedByNotSignedInRoutes {}

// IPropsGuaranteedByNotSignedInRoutes with the ROUTE_TYPE thing added to it for internal use
interface ExtraProps extends IPropsGuaranteedByNotSignedInRoutes {
  [ROUTE_TYPE_KEY]: typeof ROUTE_TYPE
}

export interface INotSignedInRouteComponentProps<
  DynamicPathPieces extends {
    [K in keyof DynamicPathPieces]?: string | undefined
  } = void,
>
  extends RouteComponentProps<DynamicPathPieces>, ExtraProps {}

interface IProps<Path extends string> extends OmitStrict<
  RouteProps<Path>,
  'component'
> {
  component: React.ComponentType<INotSignedInRouteComponentProps>
}

const NotSignedIn = <Path extends string = string>(wrongProps: IProps<Path>) => {
  const player = useSelector(s => s.authenticatedPlayerState.authenticatedPlayer)

  // need this cast because of how react-router sneaks in extra props via `<Switch>` - see the comment on TPropsCustomRouteComponentsGet
  const props = wrongProps as TPropsCustomRouteComponentsGet<Path>

  if (player) {
    console.log('You are already logged in. Redirecting to the appropriate page.')
    return (
      <Redirect
        to={{
          pathname: staticURLs.dashboard,
        }}
      />
    )
  }
  return <Route {...props} />
}

export default NotSignedIn
